export var ComponentId;
(function (ComponentId) {
    ComponentId["Footer"] = "footer";
    ComponentId["Rails"] = "carousel";
    ComponentId["Hero"] = "masthead";
    ComponentId["ShowHero"] = "content-hero";
    ComponentId["Hamburger"] = "hamburger-menu";
    ComponentId["VideoHero"] = "video-hero";
    ComponentId["Search"] = "search";
    ComponentId["ContentLists"] = "list";
    ComponentId["LikedVideos"] = "tab-bar";
    ComponentId["ShowTabs"] = "show-container";
    ComponentId["SuperstarHero"] = "overlap-container";
    ComponentId["PrivacyPolicy"] = "article-wrapper";
    ComponentId["Shorts"] = "promoted-shorts-list";
    ComponentId["MindBlown"] = "mindblown-listing";
    ComponentId["MindBlownPageHero"] = "mindblown-composite";
    ComponentId["Explore"] = "content-grid";
    ComponentId["PremiumBanner"] = "premium-benefits-hero";
    ComponentId["FeaturedStandAlone"] = "featured-standalone";
    ComponentId["ActivateConnectedDevice"] = "activate-connected-device";
    ComponentId["BannerAds"] = "banner-ad";
    ComponentId["LiveTvPlayer"] = "channel-hero-player";
    ComponentId["LiveTvChannelList"] = "content-chooser";
    ComponentId["ContestNameSetup"] = "setup-name";
    ComponentId["ContestImage"] = "contest-images";
    ComponentId["ContestStart"] = "contest-criteria";
    ComponentId["ContestAlreadyParticipated"] = "placeholder-message";
    ComponentId["Inquiry"] = "inquiry";
    ComponentId["PricePlan"] = "price-plan-wrapper";
    ComponentId["SuperstarRails"] = "carousel-superstar";
    ComponentId["ContestListing"] = "contest-listing";
    ComponentId["PromotionalBanner"] = "promotional-banner";
    ComponentId["ExploreChannelAndShows"] = "channel-listing";
    ComponentId["UserReview"] = "user-reviews";
    ComponentId["PlatformPromotion"] = "platform-promotion";
    ComponentId["SizzleReel"] = "sizzle-reel";
    ComponentId["NetworkLogos"] = "network-logos";
    ComponentId["PricePlanCompare"] = "price-plan-compare";
    ComponentId["FeaturedShowRail"] = "featured-show-rail";
    ComponentId["ContentGroup"] = "content-group";
})(ComponentId || (ComponentId = {}));

